// import React, { useState, useMemo, useEffect } from "react";
// import CustomTable from '../common/CustomTable';
// import { Select, DatePicker, Spin, Button, Modal } from 'antd';
// import { MaterialReactTable } from "material-react-table";
// import { Timesheetapi } from "../../middleware/interceptor";

// export const MyWorkItems = () => {

//     const [loading, setLoading] = useState(false)
//     const [taskListdata, setTaskListdata] = useState([])
//     const data = [...taskListdata];

//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedTask, setSelectedTask] = useState('');
//     const [modalHtmlContent, setModalHtmlContent] = useState('No description available');
//     const showModal = (taskName, rowdata) => {
//         setModalHtmlContent(rowdata);
//         setIsModalOpen(true);
//         setSelectedTask(taskName);
//     };
//     const handleOk = () => {
//         setIsModalOpen(false);
//     };
//     const handleCancel = () => {
//         setModalHtmlContent('No description available');
//         setIsModalOpen(false);
//     };


//     const columns = useMemo(
//         () => [
//             {
//                 accessorKey: "project_name",
//                 header: "Project Name",
//                 size: 80,
//                 enableColumnActions: false,
//                 muiTableHeadCellProps: {
//                     align: 'center',
//                 },
//             },
//             {
//                 accessorKey: "task_name",
//                 header: "Task Name",
//                 size: 80,
//                 enableColumnActions: false,
//                 muiTableHeadCellProps: {
//                     align: 'center',
//                 },
//                 Cell: ({ cell }) => (
//                     <div
//                         style={{ color: "#2563eb", padding: "0px", border: "0px", width: "100%", height: "100%", justifyContent: "flex-start", cursor: "pointer" }}
//                         onClick={() => showModal(cell.getValue(), cell.row.original.task_Description)}
//                     >
//                         {cell.getValue()}
//                     </div>
//                 ),
//             },
//             {
//                 accessorKey: "assigned_by",
//                 header: "Assigned By",
//                 size: 80,
//                 enableColumnActions: false,
//                 muiTableHeadCellProps: {
//                     align: 'center',
//                 },
//             },
//             {
//                 accessorKey: "start_date",
//                 header: "Start Date",
//                 size: 80,
//                 enableColumnActions: false,
//                 muiTableHeadCellProps: {
//                     align: 'center',
//                 },
//             },
//             {
//                 accessorKey: "end_date",
//                 header: "End Date",
//                 size: 80,
//                 enableColumnActions: false,
//                 muiTableHeadCellProps: {
//                     align: 'center',
//                 },
//             },
//         ],
//         [taskListdata]
//     );

//     const formatDate = (inputDate) => {
//         const date = new Date(inputDate);
//         const formatted = date.toISOString().split("T")[0];
//         return formatted;
//     }

//     const getMyWorkItems = async () => {
//         try {
//             const response = await Timesheetapi.get(
//                 `api/Projects/GetlistWorkItems?emp_id=${localStorage.getItem('employee_id')}&&Role_id=${(localStorage.getItem('emp_role_id'))}`
//             );

//             if (response.status === 200) {
//                 const lists = response.data.Task_list
//                     .filter(task => task.Item_Name) // Filters out falsy entries
//                     .map(task => ({
//                         project_name: task.Project_name,
//                         task_name: task.Item_Name,
//                         assigned_by: task.Assigned_By,
//                         start_date: formatDate(task.Start_Date),
//                         end_date: task.End_Date != null ? formatDate(task.End_Date) : "-",
//                         task_Description: task.Description != '' ? task.Description : "No description available"
//                     }));

//                 setTaskListdata(lists);
//             } else {
//                 console.error("Failed to fetch tasks:", response.status);
//             }
//         } catch (error) {
//             console.error("Error fetching work items:", error);
//         } finally {
//             setLoading(false);
//         }
//     };


//     useEffect(() => {
//         const initialRender = async () => {
//             await getMyWorkItems();
//         }
//         setLoading(true);
//         initialRender();
//     }, []);


//     return (
//         <section className='reports-section mt-[30px]'>
//             <div className="flex justify-start">

//                 <div style={{ left: "100px" }}>
//                     <div className="z-[99] left-[10px] top-[31px] py-[5px] h-[32px] w-[130px]" />
//                 </div>
//             </div>
//             <div className="mt-[-20px]  custom-table report-table">
//                 {loading ? (
//                     <>
//                         <Spin tip="Loading..." className="justify-center items-center flex" style={{ height: '200px' }}>
//                             <MaterialReactTable
//                                 columns={columns}
//                                 data={[data]} // totalRow
//                                 enableColumnFilters={false}
//                                 enableDensityToggle={false}
//                                 enableFullScreenToggle={false}
//                                 enableHiding={false}
//                                 enableSorting={true}
//                                 enableRowSelection={false}
//                                 enableColumnActions={false}
//                                 enableGlobalFilter={true}
//                                 renderTopToolbarCustomActions={() => (
//                                     <div className="page-heading px-4 relative top-[11px]">
//                                         My Activities
//                                     </div>
//                                 )}
//                             />
//                         </Spin>
//                     </>
//                 ) : (
//                     <>
//                         <MaterialReactTable
//                             columns={columns}
//                             data={data}
//                             enableColumnFilters={false}
//                             enableDensityToggle={false}
//                             enableFullScreenToggle={false}
//                             enableHiding={false}
//                             enableSorting={true}
//                             enableRowSelection={false}
//                             enableColumnActions={false}
//                             enableGlobalFilter={true}
//                             renderTopToolbarCustomActions={() => (
//                                 <div className="page-heading px-4 relative top-[11px]">
//                                     My Activities
//                                 </div>
//                             )}
//                         />
//                     </>
//                 )}
//             </div>
//             <Modal
//                 title={`Description / ${selectedTask}`}
//                 closable={{ 'aria-label': 'Custom Close Button' }}
//                 maskClosable={false}
//                 keyboard={false}
//                 open={isModalOpen}
//                 onOk={handleOk}
//                 onCancel={handleCancel}
//                 className="description-modal"
//                 footer={[
//                     <Button className="w-[90px]" key="ok" type="primary" onClick={handleOk}>
//                         OK
//                     </Button>
//                 ]}
//             >
//                 <div className="description-content">
//                     <p className="text-[12px]" dangerouslySetInnerHTML={{
//                         __html: modalHtmlContent,
//                     }}></p>
//                 </div>
//             </Modal>
//         </section>
//     );
// }


import React, { useState, useMemo, useEffect } from "react";
import {
  Skeleton,
  Input,
  Select,
  Button,
  DatePicker,
  Spin,
  Modal as AntdModal,
  Table,
} from "antd";
import { FaTrashAlt } from "react-icons/fa";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isoWeek from "dayjs/plugin/isoWeek";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Timesheetapi } from "../../middleware/interceptor";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isoWeek);

const { RangePicker } = DatePicker;

const STATUS_OPTS = [
  { value: "Open",        label: "Open"        },
  { value: "In Progress", label: "In Progress" },
  { value: "Completed",   label: "Completed"   },
];

const PRIORITY_OPTS = [
  { value: "Low",    label: "Low"    },
  { value: "Medium", label: "Medium" },
  { value: "High",   label: "High"   },
];

/* ─── MyWorkItems ─────────────────────────────────────────── */
export const MyWorkItems = () => {

  /* ── loading / data ── */
  const [countsLoading,    setCountsLoading]    = useState(true);
  const [tableLoading,     setTableLoading]     = useState(false);
  const [data,             setData]             = useState([]);
  const [rawData,          setRawData]          = useState([]);
  const [tempdata,         setTempData]         = useState([]);

  /* ── counts ── */
  const [totalCount,     setTotalCount]     = useState(0);
  const [inProgressCount,setInProgressCount]= useState(0);
  const [openCount,      setOpenCount]      = useState(0);
  const [completedCount, setCompletedCount] = useState(0);

  /* ── modals ── */
  const [deleteModal,    setDeleteModal]    = useState(false);
  const [deleteId,       setDeleteId]       = useState(null);
  const [deleteTaskName, setDeleteTaskName] = useState("");
  const [modalLoading,   setModalLoading]   = useState(false);
  const [deleteLoading,  setDeleteLoading]  = useState(false);

  /* ── description modal ── */
  const [descModal,      setDescModal]      = useState(false);
  const [descTitle,      setDescTitle]      = useState("");
  const [descHtml,       setDescHtml]       = useState("");

  /* ── inline-edit loaders (mirrors TeamsActivities) ── */
  const [statusUpdatingId,   setStatusUpdatingId]   = useState(null);
  const [startDateUpdatingId,setStartDateUpdatingId]= useState(null);
  const [endDateUpdatingId,  setEndDateUpdatingId]  = useState(null);
  const [estHrsUpdatingId,   setEstHrsUpdatingId]   = useState(null);
  const [taskNameUpdatingId, setTaskNameUpdatingId] = useState(null);

  /* ── inline-edit cell ── */
  const [editingCell,  setEditingCell]  = useState({ id: null, field: null });

  /* ── task-name confirm ── */
  const [taskNameConfirm, setTaskNameConfirm] = useState({ visible: false, record: null, value: "" });

  /* ── filters ── */
  const [searchText,        setSearchText]        = useState("");
  const [selectedStatus,    setSelectedStatus]    = useState("All");
  const [selectedProject,   setSelectedProject]   = useState("All");
  const [selectedTimePeriod,setSelectedTimePeriod]= useState("week");
  const [selectedDates,     setSelectedDates]     = useState([
    dayjs().startOf("isoWeek"),
    dayjs().endOf("isoWeek"),
  ]);
  const [sdate, setSdate] = useState(dayjs().startOf("isoWeek").format("YYYY-MM-DD"));
  const [edate, setEdate] = useState(dayjs().endOf("isoWeek").format("YYYY-MM-DD"));
  const [selectedWeekDates, setSelectedWeekDates] = useState([
    dayjs().startOf("isoWeek").toDate(),
    dayjs().endOf("isoWeek").toDate(),
  ]);
  const [pageSize, setPageSize] = useState(15);
  const estimated_hours = useMemo(
  () => data.reduce((sum, item) => sum + (item.estimated_hours || 0), 0),
  [data]
);

  /* ── dynamic project options ── */
  const PROJECT_OPTIONS = useMemo(() => {
    const unique = [...new Set(tempdata.map(t => t.project_name).filter(n => n && n !== "-").map(n => n.trim()))];
    return [{ value: "All", label: "All" }, ...unique.map(p => ({ value: p, label: p }))];
  }, [tempdata]);

  /* ──────────────────────────────────────────────────────────
     Fetch
  ────────────────────────────────────────────────────────── */
  const formatDate = (d) => (d ? new Date(d).toISOString().split("T")[0] : null);

  const fetchMyWorkItems = async () => {
    setCountsLoading(true);
    setTableLoading(true);
    try {
      const emp_id  = localStorage.getItem("employee_id");
      const role_id = localStorage.getItem("emp_role_id");
      const res = await Timesheetapi.get(
        `api/Projects/GetlistWorkItems?emp_id=${emp_id}&&Role_id=${role_id}`
      );
      if (res.status === 200) {
        const lists = (res.data.Task_list || [])
          .filter(t => t.Item_Name)
          .map((t, i) => ({
            Team_id:         t.Item_id || i + 1,
            ticket_id:       t.Ticket_id || t.Item_id?.toString() || "-",
            task_name:       t.Item_Name  || "-",
            project_name:    t.Project_name || "-",
            assigned_by:     t.Assigned_By  || "-",
            start_date:      t.Start_Date ? t.Start_Date.split("T")[0] : null,
            end_date:        t.End_Date   ? t.End_Date.split("T")[0]   : null,
            assigned_date:   t.Assigned_Date ? t.Assigned_Date.split("T")[0] : null,
            status:          t.Item_status  || "Open",
            priority:        t.Item_Priority || "Low",
            estimated_hours: parseFloat(t.Planned_hours) || 0,
            worked_hours:    parseFloat(t.Worked_Hours)  || 0,
            balance_hours:   Math.max(0, (parseFloat(t.Planned_hours) || 0) - (parseFloat(t.Worked_Hours) || 0)),
            description:     t.Description || "No description available",
          }));
        setTempData(lists);
        setRawData(lists);
      } else {
        toast.error("Failed to load activities.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load activities.");
    } finally {
      setTableLoading(false);
      setCountsLoading(false);
    }
  };



  useEffect(() => { fetchMyWorkItems();}, []);

  /* ──────────────────────────────────────────────────────────
     Filters (mirrors TeamsActivities.applyFilters exactly)
  ────────────────────────────────────────────────────────── */
  const applyFilters = () => {
    let filtered = [...tempdata];

    if (selectedProject && selectedProject !== "All")
      filtered = filtered.filter(i => i.project_name === selectedProject);

    if (selectedTimePeriod === "week" && selectedWeekDates.length === 2) {
      const ws = dayjs(selectedWeekDates[0]).startOf("day");
      const we = dayjs(selectedWeekDates[1]).endOf("day");
      filtered = filtered.filter(i => {
        const d = i.assigned_date ? dayjs(i.assigned_date) : (i.start_date ? dayjs(i.start_date) : null);
        return d && d.isSameOrAfter(ws) && d.isSameOrBefore(we);
      });
    } else if (selectedTimePeriod === "day" && selectedDates.length === 2) {
      const ds = dayjs(selectedDates[0]).startOf("day");
      const de = dayjs(selectedDates[1]).endOf("day");
      filtered = filtered.filter(i => {
        const d = i.assigned_date ? dayjs(i.assigned_date) : (i.start_date ? dayjs(i.start_date) : null);
        return d && d.isSameOrAfter(ds) && d.isSameOrBefore(de);
      });
    } else if (selectedTimePeriod === "month" && selectedDates.length === 2) {
      const ms = dayjs(selectedDates[0]).startOf("month");
      const me = dayjs(selectedDates[1]).endOf("month");
      filtered = filtered.filter(i => {
        const d = i.assigned_date ? dayjs(i.assigned_date) : (i.start_date ? dayjs(i.start_date) : null);
        return d && d.isSameOrAfter(ms) && d.isSameOrBefore(me);
      });
    } else if (selectedTimePeriod === "year" && selectedDates.length === 2) {
      const ys = dayjs(selectedDates[0]).startOf("year");
      const ye = dayjs(selectedDates[1]).endOf("year");
      filtered = filtered.filter(i => {
        const d = i.assigned_date ? dayjs(i.assigned_date) : (i.start_date ? dayjs(i.start_date) : null);
        return d && d.isSameOrAfter(ys) && d.isSameOrBefore(ye);
      });
    }

    if (searchText.trim()) {
      const q = searchText.toLowerCase();
      filtered = filtered.filter(i =>
        (i.task_name    || "").toLowerCase().includes(q) ||
        (i.ticket_id    || "").toLowerCase().includes(q) ||
        (i.project_name || "").toLowerCase().includes(q) ||
        (i.assigned_by  || "").toLowerCase().includes(q) ||
        (i.status       || "").toLowerCase().includes(q)
      );
    }

    setRawData(filtered);
  };

  useEffect(() => { applyFilters(); 
  },
    [searchText, selectedProject, selectedTimePeriod, selectedDates, selectedWeekDates, tempdata]

    
  );

  useEffect(() => {
    setData(
      selectedStatus === "All"
        ? [...rawData]
        : rawData.filter(p => (p.status || "").toLowerCase() === selectedStatus.toLowerCase())
    );
  }, [rawData, selectedStatus]);

  useEffect(() => {
    setTotalCount(rawData.length);
    setInProgressCount(rawData.filter(p => p.status === "In Progress").length);
    setOpenCount(rawData.filter(p => p.status === "Open").length);
    setCompletedCount(rawData.filter(p => p.status === "Completed").length);
  }, [rawData]);

  /* ──────────────────────────────────────────────────────────
     Time period handler (mirrors TeamsActivities exactly)
  ────────────────────────────────────────────────────────── */
  const handleTimePeriodChange = (value) => {
    setSelectedTimePeriod(value);
    const today = dayjs();
    if (value === "day") {
      setSelectedDates([today, today]);
      setSdate(today.format("YYYY-MM-DD"));
      setEdate(today.format("YYYY-MM-DD"));
    } else if (value === "week") {
      const s = today.startOf("isoWeek");
      const e = today.endOf("isoWeek");
      setSelectedDates([s, e]);
      setSdate(s.format("YYYY-MM-DD"));
      setEdate(e.format("YYYY-MM-DD"));
      setSelectedWeekDates([s.toDate(), e.toDate()]);
    } else if (value === "month") {
      setSelectedDates([today.startOf("month"), today.endOf("month")]);
      setSdate(today.startOf("month").format("YYYY-MM-DD"));
      setEdate(today.endOf("month").format("YYYY-MM-DD"));
    } else if (value === "year") {
      setSelectedDates([today.startOf("year"), today.endOf("year")]);
      setSdate(today.startOf("year").format("YYYY-MM-DD"));
      setEdate(today.endOf("year").format("YYYY-MM-DD"));
    }
  };

  const handleWeekSelection = (dates_, inst) => {
    if (inst && typeof inst.close === "function") inst.close();
    if (dates_?.length > 0) {
      const sel = dates_[0]; sel.setHours(0, 0, 0, 0);
      const start = new Date(sel);
      const dow = start.getDay();
      start.setDate(start.getDate() - (dow === 0 ? 6 : dow - 1));
      start.setHours(0, 0, 0, 0);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      end.setHours(0, 0, 0, 0);
      setSelectedWeekDates([start, end]);
      setSdate(dayjs(start).format("YYYY-MM-DD"));
      setEdate(dayjs(end).format("YYYY-MM-DD"));
      setSelectedDates([dayjs(start), dayjs(end)]);
    }
  };

  const handleDateChange = (dates) => {
    if (dates?.length === 2) {
      setSelectedDates(dates);
      setSdate(dates[0].startOf(selectedTimePeriod).format("YYYY-MM-DD"));
      setEdate(dates[1].endOf(selectedTimePeriod).format("YYYY-MM-DD"));
    }
  };

  /* ──────────────────────────────────────────────────────────
     Inline cell save (mirrors TeamsActivities.handleCellSave)
  ────────────────────────────────────────────────────────── */
  const handleCellSave = async (record, field, value) => {
    setEditingCell({ id: null, field: null });

    if (field === "task_name") {
      if (!value || value.trim() === "") { toast.error("Task name cannot be empty"); return; }
      if (value.trim() === record.task_name) return;
      setTaskNameConfirm({ visible: true, record, value: value.trim() });
      return;
    }

    if (field === "end_date") {
      const startDate = record.start_date ? dayjs(record.start_date) : null;
      if (startDate && dayjs(value).isBefore(startDate, "day")) {
        toast.error(`End date cannot be before start date (${startDate.format("DD-MM-YYYY")}).`, { autoClose: 4000 });
        return;
      }
    }

    // Optimistic update
    setTempData(prev => prev.map(t => t.Team_id === record.Team_id ? { ...t, [field]: value } : t));

    if (field === "start_date")      setStartDateUpdatingId(record.Team_id);
    else if (field === "end_date")   setEndDateUpdatingId(record.Team_id);
    else if (field === "estimated_hours") setEstHrsUpdatingId(record.Team_id);

    try {
      const res = await Timesheetapi.post("api/Tasks/UpdateTaskField", {
        item_id:     record.Team_id,
        field_name:  field,
        field_value: String(value),
      });
      if (res.data?.status === 1) {
        toast.success("Updated successfully");
      } else {
        toast.error(res.data?.message || "Update failed");
        setTempData(prev => prev.map(t => t.Team_id === record.Team_id ? { ...t, [field]: record[field] } : t));
      }
    } catch {
      toast.error("Update failed");
      setTempData(prev => prev.map(t => t.Team_id === record.Team_id ? { ...t, [field]: record[field] } : t));
    } finally {
      if (field === "start_date")          setStartDateUpdatingId(null);
      else if (field === "end_date")       setEndDateUpdatingId(null);
      else if (field === "estimated_hours") setEstHrsUpdatingId(null);
    }
  };

  const confirmTaskNameUpdate = async () => {
    const { record, value } = taskNameConfirm;
    setTaskNameConfirm({ visible: false, record: null, value: "" });
    setTempData(prev => prev.map(t => t.Team_id === record.Team_id ? { ...t, task_name: value } : t));
    setTaskNameUpdatingId(record.Team_id);
    try {
      const res = await Timesheetapi.post("api/Tasks/UpdateTaskField", {
        item_id: record.Team_id, field_name: "task_name", field_value: value,
      });
      if (res.data?.status === 1) {
        toast.success("Task name updated successfully");
      } else {
        toast.error(res.data?.message || "Update failed");
        setTempData(prev => prev.map(t => t.Team_id === record.Team_id ? { ...t, task_name: record.task_name } : t));
      }
    } catch {
      toast.error("Update failed");
      setTempData(prev => prev.map(t => t.Team_id === record.Team_id ? { ...t, task_name: record.task_name } : t));
    } finally {
      setTaskNameUpdatingId(null);
    }
  };

  /* ──────────────────────────────────────────────────────────
     Delete
  ────────────────────────────────────────────────────────── */
  const openDeleteModal = (record) => {
    setDeleteId(record.Team_id);
    setDeleteTaskName(record.task_name);
    setDeleteModal(true);
  };

  const confirmDelete = async () => {
    setModalLoading(true);
    setDeleteLoading(true);
    try {
      const res = await Timesheetapi.post("api/Tasks/DeleteTask", { item_id: deleteId });
      if (res.data?.status === 1) {
        toast.success("Task deleted successfully");
        setTempData(prev => prev.filter(t => t.Team_id !== deleteId));
        setDeleteModal(false);
        setDeleteId(null);
        setDeleteTaskName("");
      } else {
        toast.error(res.data?.message || "Failed to delete task");
      }
    } catch {
      toast.error("Error deleting task");
    } finally {
      setModalLoading(false);
      setDeleteLoading(false);
    }
  };

  /* ──────────────────────────────────────────────────────────
     Columns — identical structure to TeamsActivities
  ────────────────────────────────────────────────────────── */
  const columns = useMemo(() => [
    {
      title: "#", key: "index", width: 55, align: "center",
      render: (_, __, index) => <span className="text-[12px] text-gray-400">{index + 1}</span>,
    },
    {
      title: "Ticket ID", dataIndex: "ticket_id", key: "ticket_id", width: 110, fixed: "left",
      render: val => <span className="text-[12px] text-gray-500 font-[500]">{val || "-"}</span>,
    },
    {
      title: "Projects", dataIndex: "project_name", key: "project_name", width: 160,
      render: val => <span className="text-[13px] text-gray-700">{val || "-"}</span>,
    },
    {
      title: "Task Name", dataIndex: "task_name", key: "task_name", width: 230,
      render: (val, record) => {
        const isEditing = editingCell.id === record.Team_id && editingCell.field === "task_name";
        if (isEditing) {
          return (
            <Input
              autoFocus size="small" defaultValue={val}
              onBlur={e => handleCellSave(record, "task_name", e.target.value)}
              onPressEnter={e => handleCellSave(record, "task_name", e.target.value)}
              onClick={e => e.stopPropagation()}
            />
          );
        }
        return (
          <span
            className="text-[13px] font-[500] cursor-pointer hover:text-blue-600 hover:underline"
            style={{ color: "#4F46E5" }}
            onClick={() => {
              // Single click → open description modal; double click would edit
              setDescTitle(val);
              setDescHtml(record.description || "No description available");
              setDescModal(true);
            }}
            onDoubleClick={() => setEditingCell({ id: record.Team_id, field: "task_name" })}
            title="Click to view description · Double-click to edit"
          >
            {val || "-"}
          </span>
        );
      },
    },
    
    {
      title: "Start Date", dataIndex: "start_date", key: "start_date", width: 130,
      render: (val, record) => {
        const isEditing = editingCell.id === record.Team_id && editingCell.field === "start_date";
        if (isEditing) {
          return (
            <DatePicker
              autoFocus open size="small"
              defaultValue={val ? dayjs(val) : null}
              format="DD-MM-YYYY"
              className="w-full"
              onChange={date => { if (date) handleCellSave(record, "start_date", date.format("YYYY-MM-DD")); }}
              onOpenChange={open => { if (!open) setEditingCell({ id: null, field: null }); }}
            />
          );
        }
        return (
          <span
            className="text-[13px] text-gray-700 cursor-pointer hover:text-blue-600 hover:underline"
            onClick={() => setEditingCell({ id: record.Team_id, field: "start_date" })}
            title="Click to edit"
          >
            {val ? dayjs(val).format("DD-MM-YYYY") : "-"}
          </span>
        );
      },
    },
    {
      title: "End Date", dataIndex: "end_date", key: "end_date", width: 130,
      render: (val, record) => {
        const isEditing = editingCell.id === record.Team_id && editingCell.field === "end_date";
        if (isEditing) {
          return (
            <DatePicker
              autoFocus open size="small"
              defaultValue={val ? dayjs(val) : null}
              format="DD-MM-YYYY"
              className="w-full"
              disabledDate={current => {
                const start = record.start_date ? dayjs(record.start_date) : null;
                return start ? current && current.isBefore(start, "day") : false;
              }}
              onChange={date => { if (date) handleCellSave(record, "end_date", date.format("YYYY-MM-DD")); }}
              onOpenChange={open => { if (!open) setEditingCell({ id: null, field: null }); }}
            />
          );
        }
        return (
          <span
            className="text-[13px] text-gray-700 cursor-pointer hover:text-blue-600 hover:underline"
            onClick={() => setEditingCell({ id: record.Team_id, field: "end_date" })}
            title="Click to edit"
          >
            {val ? dayjs(val).format("DD-MM-YYYY") : "-"}
          </span>
        );
      },
    },
    {
      title: "Est. Hours", dataIndex: "estimated_hours", key: "estimated_hours", width: 100, align: "right",
      render: (val, record) => {
        const isEditing = editingCell.id === record.Team_id && editingCell.field === "estimated_hours";
        if (isEditing) {
          return (
            <Input
              autoFocus size="small" type="number" min={0}
              defaultValue={val}
              style={{ width: 80, textAlign: "right" }}
              onBlur={e => handleCellSave(record, "estimated_hours", parseFloat(e.target.value) || 0)}
              onPressEnter={e => handleCellSave(record, "estimated_hours", parseFloat(e.target.value) || 0)}
              onClick={e => e.stopPropagation()}
            />
          );
        }
        return (
          <span
            className="text-[13px] text-gray-700 cursor-pointer hover:text-blue-600 hover:underline"
            onClick={() => setEditingCell({ id: record.Team_id, field: "estimated_hours" })}
            title="Click to edit"
          >
            {val != null ? Number(val).toFixed(2) : "0.00"}
          </span>
        );
      },
    },
    {
      title: "Status", dataIndex: "status", key: "status", width: 150,
      render: (val, record) => {
        const handleStatusChange = async (newStatus) => {
          setStatusUpdatingId(record.Team_id);
          try {
            const res = await Timesheetapi.post("api/Tasks/UpdateTaskStatus", {
              item_id: record.Team_id, status: newStatus,
            });
            if (res.data?.status === 1) {
              toast.success("Status updated successfully");
              setTempData(prev => prev.map(t => t.Team_id === record.Team_id ? { ...t, status: newStatus } : t));
            } else {
              toast.error(res.data?.message || "Failed to update status");
            }
          } catch {
            toast.error("Error updating status");
          } finally {
            setStatusUpdatingId(null);
          }
        };
        return (
          <Select
            value={val}
            size="small"
            style={{ width: 130, height: "30px" }}
            options={STATUS_OPTS}
            onChange={handleStatusChange}
          />
        );
      },
    },
    {
      title: "Priority", dataIndex: "priority", key: "priority", width: 130,
      render: (val, record) => {
        const handlePriorityChange = async (newPriority) => {
          setStatusUpdatingId(record.Team_id);
          try {
            const res = await Timesheetapi.post("api/Tasks/UpdateTaskField", {
              item_id: record.Team_id, field_name: "priority", field_value: newPriority,
            });
            if (res.data?.status === 1) {
              toast.success("Priority updated successfully");
              setTempData(prev => prev.map(t => t.Team_id === record.Team_id ? { ...t, priority: newPriority } : t));
            } else {
              toast.error(res.data?.message || "Failed to update priority");
            }
          } catch {
            toast.error("Error updating priority");
          } finally {
            setStatusUpdatingId(null);
          }
        };
        const colorMap = { Low: "text-green-600", Medium: "text-orange-500", High: "text-red-500" };
        return (
          <Select
            value={val || "Low"}
            size="small"
            style={{ width: 110, height: "30px" }}
            options={PRIORITY_OPTS}
            onChange={handlePriorityChange}
            className={colorMap[val] || ""}
          />
        );
      },
    },
    ,
    {
      title: "Worked Hrs", dataIndex: "worked_hours", key: "worked_hours", width: 110, align: "center",
      render: val => {
        const isZero = !val || val === 0;
        return (
          <span className={`text-[12px] font-[500] ${isZero ? "text-gray-400" : "text-blue-600"}`}>
            {val != null ? Number(val).toFixed(2) : "0.00"}
          </span>
        );
      },
    },
    {
      title: "Balance Hrs", dataIndex: "balance_hours", key: "balance_hours", width: 110, align: "right",
      render: val => (
        <span className={`text-[13px] font-[500] ${val < 0 ? "text-red-500" : val === 0 ? "text-green-600" : "text-orange-500"}`}>
          {val != null ? Number(val).toFixed(2) : "0.00"}
        </span>
      ),
    },
    {
      title: "Assigned By", dataIndex: "assigned_by", key: "assigned_by", width: 170,
      render: val => {
        if (!val || val === "-") return <span className="text-[13px] text-gray-700">-</span>;
        return (
          <div className="flex items-center gap-[6px]">
            <div
              className="flex items-center justify-center text-[10px] font-[600] rounded-full flex-shrink-0"
              style={{
                width: 24, height: 24,
                background: "#EEF2FF", color: "#3730A3",
              }}
            >
              {val.split(" ").map(p => p[0] || "").join("").toUpperCase().slice(0, 2)}
            </div>
            <span className="text-[12px] text-gray-700">{val}</span>
          </div>
        );
      },
    },
    {
      title: "Action", key: "action", width: 70, align: "center", fixed: "right",
      render: (_, record) => (
        <FaTrashAlt
          onClick={() => openDeleteModal(record)}
          className="text-[14px] text-[#ff4d4d] cursor-pointer mx-auto"
        />
      ),
    },
  ], [data, editingCell]);

  /* ──────────────────────────────────────────────────────────
     Render
  ────────────────────────────────────────────────────────── */
  return (
    <div>
      <ToastContainer />

      <Spin
        spinning={
          statusUpdatingId    !== null ||
          deleteLoading                ||
          startDateUpdatingId !== null ||
          endDateUpdatingId   !== null ||
          estHrsUpdatingId    !== null ||
          taskNameUpdatingId  !== null
        }
        tip={
          deleteLoading               ? "Deleting task..."            :
          statusUpdatingId   !== null ? "Updating status..."          :
          startDateUpdatingId!== null ? "Updating start date..."      :
          endDateUpdatingId  !== null ? "Updating end date..."        :
          estHrsUpdatingId   !== null ? "Updating estimated hours..."  :
          taskNameUpdatingId !== null ? "Updating task name..."       : ""
        }
        size="large"
      >
        <div className="mx-auto px-0">

          {/* Page heading */}
          <div className="mb-[5px]">
            <h2 className="page-heading relative bottom-[-10px]">MY ACTIVITIES</h2>
          </div>

          {/* ── Summary Cards ── */}
          <div className="mt-6">
            <div className="flex flex-wrap gap-4">
              {[
                { label: "Total Tasks",      count: totalCount,      color: "text-blue-600",   sub: "All Projects"          },
                { label: "In Progress",      count: inProgressCount, color: "text-green-600",  sub: "Status: In Progress"   },
                { label: "Open Tasks",       count: openCount,       color: "text-yellow-500", sub: "Status: Open"          },
                { label: "Completed Tasks",  count: completedCount,  color: "text-purple-600", sub: "Status: Completed"     },
              ].map(({ label, count, color, sub }) => (
                <div key={label} className="flex-1 min-w-[160px] p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
                  <div className="text-center">
                    <span className="text-[12px] font-[500] text-gray-600">{label}</span>
                    <div className={`text-[28px] font-[600] ${color} mt-2`}>
                      {countsLoading
                        ? <Skeleton active paragraph={false} title={false} className="w-[60px] mx-auto" />
                        : count}
                    </div>
                    <span className="text-[11px] text-gray-500 block mt-1">{sub}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Filters ── */}
          <div className="flex justify-between items-end gap-[15px] mt-3 z-[9]">
            <div className="flex items-end gap-2 flex-wrap">

              {/* Projects */}
              <div className="w-[130px] flex flex-col gap-[5px]">
                <label className="text-[13px] pl-2">Projects:</label>
                <Select
                  value={selectedProject}
                  onChange={v => setSelectedProject(v)}
                  options={PROJECT_OPTIONS}
                  placeholder="Select Project"
                />
              </div>

              {/* Status */}
              <div className="w-[120px] flex flex-col gap-[5px]">
                <label className="text-[13px] pl-2">Status:</label>
                <Select
                  value={selectedStatus}
                  onChange={v => setSelectedStatus(v)}
                  options={[{ label: "All", value: "All" }, ...STATUS_OPTS]}
                  placeholder="Select Status"
                />
              </div>

              {/* Time Period */}
              <div className="flex flex-col gap-[5px]">
                <label className="text-[13px] pl-2">Time Period:</label>
                <Select
                  style={{ width: 150 }}
                  value={selectedTimePeriod}
                  options={[
                    { label: "Day",            value: "day"   },
                    { label: "Weekly Report",  value: "week"  },
                    { label: "Monthly Report", value: "month" },
                    { label: "Yearly Report",  value: "year"  },
                  ]}
                  onChange={handleTimePeriodChange}
                />
              </div>

              {/* Date picker — same conditional logic as TeamsActivities */}
              <div className="flex flex-col gap-[5px]">
                <label className="text-[13px] pl-2">Date:</label>
                {selectedTimePeriod === "month" && (
                  <RangePicker
                    className="w-[260px]" allowClear={false}
                    value={selectedDates} picker="month"
                    placeholder={["Start Month", "End Month"]} format="MMMM YYYY"
                    onChange={handleDateChange}
                    disabledDate={c => c && c > dayjs().endOf("month")}
                  />
                )}
                {selectedTimePeriod === "year" && (
                  <RangePicker
                    className="w-[200px]" allowClear={false}
                    value={selectedDates} picker="year"
                    placeholder={["Start Year", "End Year"]} format="YYYY"
                    onChange={handleDateChange}
                    disabledDate={c => c && c.year() > dayjs().year()}
                  />
                )}
                {selectedTimePeriod === "day" && (
                  <RangePicker
                    className="w-[250px]" allowClear={false}
                    value={selectedDates}
                    placeholder={["Start Date", "End Date"]} format="DD-MM-YYYY"
                    onChange={handleDateChange}
                    disabledDate={c => c && c > dayjs().endOf("day")}
                  />
                )}
                {selectedTimePeriod === "week" && (
                  <Flatpickr
                    className="ant-select ant-select-outlined w-[180px] date-picker-client-report custom-date-picker-client-report"
                    value={selectedWeekDates}
                    options={{
                      mode: "range",
                      dateFormat: "D, M j",
                      onChange: handleWeekSelection,
                    }}
                    placeholder="Select Week"
                  />
                )}
              </div>

              {/* Search */}
              <div className="flex flex-col gap-[5px]">
                <label className="text-[13px]">Search</label>
                <Input
                  placeholder="Search by Task, Project, Assigned By..."
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                  allowClear
                  prefix={<i className="fa fa-search text-gray-400"></i>}
                  className="h-[32px] w-[280px]"
                />
              </div>

            </div>
          </div>

          {/* ── Table ── */}
          <div className="mt-5 overflow-auto custom-table custom-teams-activity absolute w-[98%]">
            <Spin spinning={tableLoading} tip="Loading...">
              <Table
                columns={columns}
                dataSource={data}
                rowKey="Team_id"
                size="small"
                bordered
                scroll={{ x: "max-content", y: 400 }}
                sticky={{ offsetHeader: 0 }}
                pagination={{
                  pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ["15", "25", "50", "100"],
                  showTotal: (total, range) => (
      <span>
        Total {total} records&nbsp;&nbsp;|&nbsp;&nbsp;Estimated Effort: {estimated_hours} hrs
      </span>
    ),
                  onShowSizeChange: (_, size) => setPageSize(size),
                  onChange:         (_, size) => setPageSize(size),
                }}
                locale={{ emptyText: "No records found" }}
                rowClassName={(_, index) => index % 2 === 0 ? "bg-white" : "bg-[#fafafa]"}
              />

              <span className="justify-end">
                <p className="text-right text-sm">Total Effort Hours : {estimated_hours} </p>
              </span>
            </Spin>
          </div>

        </div>
      </Spin>

      {/* ── Delete Confirmation Modal ── */}
      <AntdModal
        title={<><ExclamationCircleFilled style={{ color: "orange", marginRight: 8 }} />Confirm</>}
        open={deleteModal}
        onCancel={() => { setDeleteModal(false); setDeleteId(null); }}
        closable maskClosable={false} keyboard={false}
        footer={[
          <Button key="cancel" onClick={() => { setDeleteModal(false); setDeleteId(null); }}>Cancel</Button>,
          <Button key="confirm" type="primary" danger loading={modalLoading} onClick={confirmDelete}>Delete</Button>,
        ]}
      >
        <p>Are you sure you want to delete: <strong>"{deleteTaskName}"</strong>?</p>
        <p>This action cannot be undone.</p>
      </AntdModal>

      {/* ── Task Name Confirmation Modal ── */}
      <AntdModal
        title={<span><ExclamationCircleFilled style={{ color: "#faad14", marginRight: 8 }} />Confirm Task Name Update</span>}
        open={taskNameConfirm.visible}
        onCancel={() => setTaskNameConfirm({ visible: false, record: null, value: "" })}
        closable maskClosable={false} keyboard={false}
        footer={[
          <Button key="cancel" onClick={() => setTaskNameConfirm({ visible: false, record: null, value: "" })}>Cancel</Button>,
          <Button key="confirm" type="primary" onClick={confirmTaskNameUpdate}>Yes, Update</Button>,
        ]}
      >
        <div className="py-2">
          <p className="text-[13px] text-gray-600 mb-3">Are you sure you want to update the task name?</p>
          <div className="bg-gray-50 rounded p-3 border border-gray-200">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-[12px] text-gray-500 w-[60px]">From:</span>
              <span className="text-[13px] font-[500] text-red-500 line-through">{taskNameConfirm.record?.task_name}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-[12px] text-gray-500 w-[60px]">To:</span>
              <span className="text-[13px] font-[600] text-green-600">{taskNameConfirm.value}</span>
            </div>
          </div>
        </div>
      </AntdModal>

      {/* ── Description Modal ── */}
      <AntdModal
        title={
          <span className="text-[14px] font-[600]">
            Description / {descTitle}
          </span>
        }
        open={descModal}
        onCancel={() => setDescModal(false)}
        closable maskClosable={false} keyboard={false}
        footer={[
          <Button key="ok" type="primary" onClick={() => setDescModal(false)}>OK</Button>,
        ]}
      >
        <div className="description-content">
          <p className="text-[12px]" dangerouslySetInnerHTML={{ __html: descHtml }} />
        </div>
      </AntdModal>

    </div>
  );
};